var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.tree).length)?_c('vx-card',{staticClass:"access-groups-list main-box top-zero-radius md:w-1/2 mx-auto"},[_c('crud-tree',{attrs:{"tree":_vm.tree,"first":true,"options":_vm.options},model:{value:(_vm.selectedRows),callback:function ($$v) {_vm.selectedRows=$$v},expression:"selectedRows"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }